/**
 * AIMÉ – „Als Hint schicken“
 * Baut aus Produktname, aktueller Auswahl und Link eine kleine Wunsch-Nachricht.
 * Produktseite: liest Variante und Personalisierung (properties[...]) nur aus – verändert nichts.
 * Atelier: nutzt das Design-Objekt der Section (root.aimeDesign.hint()).
 */
(function () {
  'use strict';
  if (window.__aimeHint) return;
  window.__aimeHint = true;

  var SIZE = /gr(ö|oe)(ß|ss)e|size/i;

  // Auswahl auf der Produktseite: Variante + ausgefüllte Personalisierungsfelder
  function pdpSelection(el) {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return '';
    var personal = [], letters = [], sizes = [], variant = '';
    var sel = form.querySelector('select[name="id"]');
    if (sel && sel.selectedIndex > -1) {
      var v = sel.options[sel.selectedIndex].text.split(' - ')[0].trim();
      if (v && !/default title/i.test(v)) variant = v.replace(/\s*\/\s*/g, ' · ');
    }
    var seen = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (f) {
      var key = f.name.slice(11, -1), val = (f.value || '').trim();
      if (seen[key] || !val || val === '-' || f.type === 'file' || key.charAt(0) === '_') return;
      if (f.offsetParent === null && f.type !== 'hidden') return;
      seen[key] = true;
      if (/^(position|feld)\s*#?\s*\d+/i.test(key)) letters.push(val.replace(/\s*\(.*\)$/, ''));
      else if (SIZE.test(key)) sizes.push('Größe ' + val);
      else personal.push(val);
    });
    // Reihenfolge wie im Gespräch: Initialen · Gold · Größe
    var parts = [];
    if (letters.length) parts.push(letters.join(' '));
    parts = parts.concat(personal);
    if (variant) parts.push(variant);
    return parts.concat(sizes).join(' · ');
  }

  function payload(el) {
    var intro = el.getAttribute('data-intro') || '';
    var title = el.getAttribute('data-title') || document.title;
    var url = el.getAttribute('data-url') || window.location.href.split('#')[0];
    var selection = '';
    if (el.getAttribute('data-source') === 'atelier') {
      var root = el.closest('[data-aime-generator]');
      if (root && root.aimeDesign && root.aimeDesign.hint) {
        var h = root.aimeDesign.hint();
        title = h.title || title; selection = h.selection || ''; url = h.url || url;
      }
    } else if (el.hasAttribute('data-selection')) {
      selection = el.getAttribute('data-selection'); // z. B. Geschenk-Modus: Initialen
    } else {
      selection = pdpSelection(el);
    }
    var text = intro + ' ' + title + (selection ? ' · ' + selection : '');
    return { title: title, text: text, url: url, full: text + '\n' + url };
  }

  function close(el) {
    var menu = el.querySelector('[data-hint-menu]'), btn = el.querySelector('[data-hint-open]');
    if (menu) menu.hidden = true;
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-hint-open]');
    if (open) {
      var el = open.closest('[data-aime-hint]'), p = payload(el);
      if (navigator.share && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
        navigator.share({ title: p.title, text: p.text, url: p.url }).catch(function () {});
        return;
      }
      var menu = el.querySelector('[data-hint-menu]');
      el.querySelector('[data-hint-wa]').href = 'https://wa.me/?text=' + encodeURIComponent(p.full);
      el.querySelector('[data-hint-mail]').href = 'mailto:?subject=' + encodeURIComponent(el.getAttribute('data-subject') || '') + '&body=' + encodeURIComponent(p.full);
      menu.hidden = !menu.hidden;
      open.setAttribute('aria-expanded', String(!menu.hidden));
      return;
    }
    var copy = e.target.closest('[data-hint-copy]');
    if (copy) {
      var el2 = copy.closest('[data-aime-hint]'), p2 = payload(el2), label = copy.textContent;
      var done = function () { copy.textContent = 'Link kopiert'; setTimeout(function () { copy.textContent = label; close(el2); }, 1600); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(p2.full).then(done, done);
      else { var ta = document.createElement('textarea'); ta.value = p2.full; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (err) {} ta.remove(); done(); }
      return;
    }
    if (e.target.closest('[data-hint-wa], [data-hint-mail]')) { var el3 = e.target.closest('[data-aime-hint]'); setTimeout(function () { close(el3); }, 300); return; }
    document.querySelectorAll('[data-aime-hint]').forEach(function (h) { if (!h.contains(e.target)) close(h); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('[data-aime-hint]').forEach(close);
  });
})();
